<template>
  <div class="navbar">
    <hamburger
      :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
    >
    </hamburger>
    <breadcrumb class="breadcrumb-container"></breadcrumb>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <svg-icon icon-class="user-outline" class="user-icon"></svg-icon>
        <span class="user-name">{{ name }}</span>
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu slot="dropdown" class="user-dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            <span style="display: block;text-align: center">首页</span>
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span style="display:block;text-align: center" @click="handleModify">修改密码</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span style="display:block;text-align: center" @click="logout">登出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- 对话框 -->
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="right"
        label-width="80px"
        style="width: 400px; margin-left:40px;"
      >
        <el-form-item label="原密码" prop="oldPass">
          <el-input type="password" v-model="temp.oldPass" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="新密码" prop="newPass">
          <el-input type="password" v-model="temp.newPass" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPass">
          <el-input type="password" v-model="temp.confirmPass" autocomplete="off"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">关闭</el-button>
        <el-button type="primary" @click="modifyPass">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { modifyPass } from '@/api/login'
import md5 from 'js-md5'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    let validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.temp.confirmPass !== '') {
          this.$refs.dataForm.validateField('confirmPass')
        }
        callback()
      }
    }
    let validateConfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.temp.newPass) {
        callback(new Error('两次输入密码不一致！'))
      } else {
        callback()
      }
    }
    return {
      dialogFormVisible: false,
      temp: {
        oldPass: '',
        newPass: '',
        confirmPass: ''
      },
      rules: {
        oldPass: [
          {
            required: true,
            message: '请输入原密码',
            trigger: ['change', 'blur']
          }
        ],
        newPass: [
          {
            validator: validateNewPass,
            trigger: ['change', 'blur']
          },
          {
            required: true,
            message: '请输入密码'
          },
          {
            min: 6,
            max: 16,
            message: '密码长度不能少于6位,且不能大于16位',
            trigger: 'blur'
          }
        ],
        confirmPass: [
          {
            validator: validateConfirmPass,
            trigger: ['change', 'blur']
          },
          {
            required: true,
            message: '请再次输入密码'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'userid'])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('FedLogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },

    resetTemp() {
      this.temp = {
        oldPass: '',
        newPass: '',
        confirmPass: ''
      }
    },

    // 修改密码事件
    handleModify() {
      this.resetTemp()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },

    modifyPass() {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          let data = {
            userId: this.userid,
            oldPass: md5(this.temp.oldPass).toUpperCase(),
            newPass: md5(this.temp.newPass).toUpperCase()
          }
          modifyPass(data).then(() => {
            this.dialogFormVisible = false
            this.$message({
              message: '密码修改成功',
              type: 'success'
            })
          })
        }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0 !important;
  -webkit-box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-bottom: none !important;

  .hamburger-container {
    line-height: 50px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }

  .breadcrumb-container {
    float: left;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 50px;
    line-height: 50px;
    display: inline-block;
    position: absolute;
    right: 20px;

    .avatar-wrapper {
      cursor: pointer;
      position: relative;

      .user-name {
        width: 40px;
        height: 50px;
        font-size: larger;
      }

      .el-icon-caret-bottom {
        margin-left: 5px;
        font-size: 12px;
      }
    }
  }
}
</style>
